enum AuthenticationStatus {
  UNAUTHORIZED = 'UNAUTHORIZED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  PENDING_CONFIRMATION = 'PENDING_CONFIRMATION',
  CONFIRMATION = 'CONFIRMATION',
  AUTHENTICATED = 'AUTHENTICATED'
}

export default AuthenticationStatus;
